import { render } from "./LegendList.vue?vue&type=template&id=08d070b6&scoped=true"
import script from "./LegendList.vue?vue&type=script&lang=js"
export * from "./LegendList.vue?vue&type=script&lang=js"

import "./LegendList.vue?vue&type=style&index=0&id=08d070b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d070b6"]])

export default __exports__